//this file is for storing any magic strings that are used in code and compared for equality
//different types of injured parties
export const INJURED_PASSENGERS = "InjuredPassengers";
export const INJURED_OTHER_PASSENGERS = "InjuredOtherPassengers";
export const INJURED_PEDESTRIANS = "InjuredPedestrians";
export const PERSONAL = "PERSONAL";
export const COMMERCIAL = "COMMERCIAL";
export const formTypes = {
  Auto: "Auto",
  Vehicle: "Vehicle",
  Garage: "Garage Owners",
  AutoGlass: "Auto Glass",
  Home: "Homeowners",
  Property: "Property",
  Liability: "Liability",
  PropertyLiability: "Property/Liability",
  WorkersComp: "Workers' Compensation",
};
export const damageKeys = {
  Property: "Property",
  Liability: "Liability",
};
export const idleExpiryKey ="ng2Idle.UserIdleWatcher.expiry";
export const idleIdlingKey = "ng2Idle.UserIdleWatcher.idling";
